import { useState, useRef, useEffect } from "react";
import clientLogo from "../assets/BrightCity-logo-small.png";
import userprofile from "../assets/businessman.png";
import ResetPasswordModal from "./userResetPassword";


export default function Navbar({ isLoggedIn, onLogout }) {
  const [showMenu, setShowMenu] = useState(false);
  const [showUserResetModal, setShowUserResetModal] = useState(false);
  const menuRef = useRef();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Get user data from localStorage
  const userData = JSON.parse(localStorage.getItem("userInfo")) || {};

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
    <nav
      style={{
        position: "sticky",
        top: 0,
        zIndex: "1000",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: isMobile ? "0px 12px" : "0px 30px",
        background: "linear-gradient(90deg, #1b66d1, #0b3d5c)",
        color: "#fff",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        flexWrap: "wrap",
        minHeight: isMobile ? "50px" : "55px"
      }}
    >
      {/* Left: Logo */}
      <div style={{ display: "flex", alignItems: "center", gap: isMobile ? "6px" : "8px" }}>
        <img
          src={clientLogo}
          alt="BrightCity Logo"
          style={{ height: isMobile ? "28px" : "32px", width: isMobile ? "28px" : "32px" }}
        />
        <h5 style={{ margin: 0, fontSize: isMobile ? "1rem" : "1.25rem", whiteSpace: "nowrap" }}>BrightCity</h5>
      </div>

      {/* Right: Profile + Logout */}
      {isLoggedIn && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: isMobile ? "8px" : "12px",
            position: "relative"
          }}
        >
          
    
            <b
              style={{ cursor: "pointer", whiteSpace: "nowrap" }}
              onClick={(e) => {
                e.stopPropagation();
                setShowMenu(!showMenu);
              }}
            >
              {userData.name}
            </b>
       

          {/* Dropdown */}
          {showMenu && (
            <div
              ref={menuRef}
              style={{
                position: "absolute",
                top: isMobile ? "50px" : "45px",
                right: isMobile ? "0px" : "40px",
                width: isMobile ? "min(90vw, 350px)" : "300px",
                maxHeight: "80vh",
                overflowY: "auto",
                background: "#fff",
                color: "#000",
                borderRadius: "12px",
                boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
                padding: "15px",
                zIndex: 4000
              }}
            >
              {/* Profile Header */}
               <div style={{ textAlign: "center", marginBottom: "12px" }}>
                   <img
                     src={userprofile}
                     alt="Profile"
                     onError={(e) => (e.target.style.display = "none")}
                     style={{
                       height: isMobile ? "45px" : "50px",
                       width: isMobile ? "45px" : "50px",
                       borderRadius: "50%",
                       objectFit: "cover",
                       display: "block",
                       margin: "auto"
                     }}
                   />
                 
                  <div style={{ fontSize: "20px", lineHeight: "1.3", margin: "8px 0", wordWrap: "break-word" }}>
                   <p style={{ margin: "3px 0", fontSize: "20px", fontWeight: "600" }}>
                     {userData.name}
                   </p>
                   <p style={{ margin: "2px 0" }}>
                     <small>{userData.rolename}</small>
                   </p>
                   <p style={{ margin: "2px 0" }}>
                     <small>{userData.mobile}</small>
                   </p>
                   <p style={{ margin: "2px 0", wordWrap: "break-word", overflowWrap: "break-word", fontSize: "15px" }}>
                     <small>{userData.email}</small>
                   </p>
                 </div>
                 
               </div>

               <hr style={{ margin: "8px 0" }} />

                   <div style={{ fontSize: "20px", lineHeight: "1.3", margin: "6px 0", wordWrap: "break-word" }}>
                     {[1,2,5,11,21,23,31,35,51,55,57,61,63].includes(Number(userData.role)) && (
                       <p style={{ margin: "2px 0" }}>
                       <small>Agency: <b>{userData.agency}</b></small>
                     </p>)}
                     {[63,61].includes(Number(userData.role)) && (
                       <p style={{ margin: "2px 0" }}>
                       <small>Zone: <b>{userData.zone}</b></small>
                     </p>)}
                     {[63,61].includes(Number(userData.role)) && (
                       <p style={{ margin: "2px 0" }}>
                       <small>Ward: <b>{userData.ward}</b></small>
                     </p>)}
                     {[63,61].includes(Number(userData.role)) && (
                       <p style={{ margin: "2px 0" }}>
                       <small>Manager: <b>{userData.manager}</b></small>
                     </p>)}
                     {[63].includes(Number(userData.role)) && (
                       <p style={{ margin: "2px 0" }}>
                       <small>Op. In.: <b>{userData.operationIncharge}</b></small>
                     </p>)}
                     {[65].includes(Number(userData.role)) && (
                       <p style={{ margin: "2px 0" }}>
                       <small>Zonal In.: <b>{userData.zonalIncharge}</b></small>
                     </p>)}
                   </div>
                 
               <hr style={{ margin: "8px 0" }} />

               <div style={{display: "flex", alignItems: "center", gap: "10px", padding: "0px 0", cursor: "pointer", fontSize: "16px"}} onClick={(e) => {
                   e.stopPropagation(); 
                   setShowMenu(false);
                   setShowUserResetModal(true);
                 }}>
                 <i className="material-icons" style={{fontSize: "16px"}}>lock</i>
                 <span>Reset Password</span>
               </div>
             </div>
           )}
             
          <i className="material-icons" style={{ fontSize: isMobile ? "22px" : "26px", cursor: "pointer", marginTop: "2px" }} onClick={onLogout} title="Logout">logout</i>
        </div>
      )}
    </nav>
    {showUserResetModal && (
            <ResetPasswordModal onClose={() => {setShowUserResetModal(false)}} onLogout={onLogout} />
          )}
    </>
    
  );
}
